const BASE_URL = process.env.BUN_PUBLIC_API_BASE_URL;

export interface Notification {
  notification_id: string;
  recipient_user_id: string;
  actor_user_id: string | null;
  action_type: string;
  body: string;
  is_read: boolean;
  read_at: string | null;
  redirect_path: string;
  channel_key: string;
  created_at: string;
}

class NotificationsProvider {
  private async request<T>(path: string, options?: RequestInit): Promise<T> {
    const res = await fetch(`${BASE_URL}${path}`, {
      ...options,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });

    if (res.status === 401) {
      window.dispatchEvent(new CustomEvent("auth:unauthorized"));
      throw new Error("Unauthorized");
    }

    if (!res.ok) {
      const text = await res.text().catch(() => "Unknown error");
      throw new Error(text || `HTTP ${res.status}`);
    }

    const text = await res.text();
    try {
      return JSON.parse(text) as T;
    } catch {
      return text as unknown as T;
    }
  }

  list(unreadOnly?: boolean): Promise<Notification[]> {
    const qs = unreadOnly ? "?unread=true" : "";
    return this.request<Notification[]>(`/v1/users/notifications${qs}`);
  }

  markRead(id: string): Promise<void> {
    return this.request<void>(`/v1/users/notifications/${id}/read`, {
      method: "PATCH",
    });
  }
}

export const notificationsProvider = new NotificationsProvider();
